import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListStudentSemesterScore = createAsyncThunk('student-score-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-score/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const createStudentScore = createAsyncThunk('student-score-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ApproveStudentScore = createAsyncThunk('student-score-approve', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/approve`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ListStudentSemesterFinalScore = createAsyncThunk('student-final-score-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-score/final-exam-score-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const createStudentFinalScore = createAsyncThunk('student-final-score-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/final-exam-score-store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ApproveStudentFinalScore = createAsyncThunk('student-final-score-approve', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/final-exam-score-approve`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ListStudentSemesterSecondScore = createAsyncThunk('student-second-score-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-score/second-exam-score-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const createStudentSecondScore = createAsyncThunk('student-second-score-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/second-exam-score-store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ApproveStudentSecondScore = createAsyncThunk('student-second-score-approve', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/second-exam-score-approve`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ListStudentSemesterThirdScore = createAsyncThunk('student-third-score-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-score/third-exam-score-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const createStudentThirdScore = createAsyncThunk('student-third-score-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/third-exam-score-store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ApproveStudentThirdScore = createAsyncThunk('student-third-score-approve', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/third-exam-score-approve`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ListStudentSemesterFourthScore = createAsyncThunk('student-fourth-score-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-score/fourth-exam-score-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const createStudentFourthScore = createAsyncThunk('student-fourth-score-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/fourth-exam-score-store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ApproveStudentFourthScore = createAsyncThunk('student-fourth-score-approve', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/fourth-exam-score-approve`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const studentScoreReport = createAsyncThunk('student-score-report', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/report-score`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const PrintStudentScore = createAsyncThunk('student-score-report-print', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/print-report-score`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const PrintEmptyScore = createAsyncThunk('student-score-empty-print', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-score/print-empty-score`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

type studentScoreState = {
  errors: any
}

const initialState: studentScoreState = {
  errors: '',
}

export const studentScoreSlice = createSlice({
  name: 'student-score',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
  },
})

export const { reset } = studentScoreSlice.actions
export default studentScoreSlice.reducer
